.c9{border:1px solid #ddd;}